{
  "bookmarkTitleLabel": "Bookmarks",
  "debug": "Debug",
  "devConnectionLabel": "Developer Connection",
  "exlSection": "Results from Experience League",
  "feedback": "Feedback",
  "fetchFailed": "Fetch Failed",
  "help": "Help",
  "helpDefaultFeatured": "Adobe Experience Cloud Learn & Support",
  "helpLoadError": "Something went wrong. Please try again.",
  "noBookmarks": "Bookmark help content to access it here",
  "noBookmarksTitle": "No bookmarks",
  "noResults": "No Results Found",
  "noResultsMessage": "Check the spelling or try a different search term",
  "resourcesCustomerCareLabel": "Customer Care",
  "resourcesStatusLabel": "Status",
  "support": "Support"
}
